export const storeKeys = {
  all: ['store'] as const,
  details: () => [...storeKeys.all, 'details'] as const,
} as const
